import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { AddImagesPlaceholder } from './add-images-placeholder';

const getStyles = () => ({
  forcePositioning: {
    top: '-170px',
    left: '218px',
  },
});

const UnstyledAddImagesPlaceholderWithPositioning = ({
  i18n,
  onClick,
  itemCount,
  classes,
  className,
}) => {
  // Need to position this placeholder next to the last image
  const shouldReposition = itemCount % 2 !== 0;

  return (
    <AddImagesPlaceholder
      i18n={i18n}
      onClick={onClick}
      className={classNames(
        shouldReposition ? classes.forcePositioning : null,
        className
      )}
    />
  );
};

UnstyledAddImagesPlaceholderWithPositioning.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  itemCount: PropTypes.number.isRequired,
  className: PropTypes.string,
};

UnstyledAddImagesPlaceholderWithPositioning.defaultProps = {
  className: null,
};

export const AddImagesPlaceholderWithPositioning = withDefaultStyles(
  UnstyledAddImagesPlaceholderWithPositioning,
  getStyles
);
